import { IconAlertTriangle, IconNote } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Tooltip } from '@rossum/ui/material';
import { GridRenderCellParams } from '@rossum/ui/x-data-grid-pro';
import { TransformedOperation } from '../helpers';

export const ErrorNote = ({
  value: error,
}: GridRenderCellParams<TransformedOperation, string>) => {
  if (!error) return null;
  return (
    <Tooltip
      title={
        <Stack direction="column" spacing={0.5} alignItems="center">
          <SvgIcon fontSize="medium" color="error">
            <IconAlertTriangle />
          </SvgIcon>
          <Stack spacing={0}>
            <div>{error}</div>
          </Stack>
        </Stack>
      }
      placement="top"
    >
      <SvgIcon fontSize="medium" color="action">
        <IconNote />
      </SvgIcon>
    </Tooltip>
  );
};
